import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const RegisterEditionBox = styled.div `
  padding-bottom: 1.5rem;
  .register-one {
    display: flex;
    padding-bottom: 1.2rem;
    flex-direction: column;

    > p {
      ${Font.sansRegular};
      font-size: 14px;
      line-height: 22px;
      color: ${Color.grey};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
         color:${ColorDark.textLight};
        }
      }
      > span {
        ${Font.sansBold};
        margin-bottom: 0.5rem;
      }
    }
  }
  .register-two {
    p {
      ${Font.sansRegular};
      font-size: 12px;
      line-height: 18px;
      color: ${Color.grey};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
          color:${ColorDark.textLight};
        }
      }
    }
  }
  .register-three {
    display: flex;
    flex-direction: row;
    padding: 0.5rem 0;
    align-items: center;
    span {
      ${Font.sansRegular};
      margin-left: 10px;
      font-size: 12px;
      color: ${Color.grey};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
          color:${ColorDark.textLight};
        }
      }
    }
  }
`;